import { StyleFilter } from "@globalTypes"

export const uidToProductgroups = {
  rings: "ring",
  earrings: "earring",
  bracelets: "bracelet",
  necklaces: "necklace",
}

export const articleCombinationFilters = {
  rings: [StyleFilter.classic, StyleFilter.oval, StyleFilter.onepiece],
  earrings: [
    StyleFilter.hippiechic,
    StyleFilter.classic,
    StyleFilter.oval,
    StyleFilter.onepiece,
  ],
  bracelets: [
    StyleFilter.classic,
    StyleFilter.oval,
    StyleFilter.twin,
    StyleFilter.onepiece,
  ],
  necklaces: [StyleFilter.classic, StyleFilter.oval, StyleFilter.onepiece],
}
